// @generated by protobuf-ts 2.9.0 with parameter generate_dependencies,force_optimize_code_size,long_type_string,ts_nocheck
// @generated from protobuf file "app/data/v1/data.proto" (package "viam.app.data.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { DataService } from "./data";
import type { GetSequenceBinaryDataResponse } from "./data";
import type { GetSequenceBinaryDataRequest } from "./data";
import type { SequencesByDatasetIDResponse } from "./data";
import type { SequencesByDatasetIDRequest } from "./data";
import type { ListSequencesResponse } from "./data";
import type { ListSequencesRequest } from "./data";
import type { DeleteSequenceResponse } from "./data";
import type { DeleteSequenceRequest } from "./data";
import type { UpdateSequenceResponse } from "./data";
import type { UpdateSequenceRequest } from "./data";
import type { GetSequenceResponse } from "./data";
import type { GetSequenceRequest } from "./data";
import type { CreateSequenceResponse } from "./data";
import type { CreateSequenceRequest } from "./data";
import type { CreateBinaryDataSignedURLResponse } from "./data";
import type { CreateBinaryDataSignedURLRequest } from "./data";
import type { ListSavedQueriesResponse } from "./data";
import type { ListSavedQueriesRequest } from "./data";
import type { DeleteSavedQueryResponse } from "./data";
import type { DeleteSavedQueryRequest } from "./data";
import type { GetSavedQueryResponse } from "./data";
import type { GetSavedQueryRequest } from "./data";
import type { UpdateSavedQueryResponse } from "./data";
import type { UpdateSavedQueryRequest } from "./data";
import type { CreateSavedQueryResponse } from "./data";
import type { CreateSavedQueryRequest } from "./data";
import type { DeleteIndexResponse } from "./data";
import type { DeleteIndexRequest } from "./data";
import type { ListIndexesResponse } from "./data";
import type { ListIndexesRequest } from "./data";
import type { CreateIndexResponse } from "./data";
import type { CreateIndexRequest } from "./data";
import type { RemoveSequencesFromDatasetResponse } from "./data";
import type { RemoveSequencesFromDatasetRequest } from "./data";
import type { AddSequencesToDatasetResponse } from "./data";
import type { AddSequencesToDatasetRequest } from "./data";
import type { RemoveBinaryDataFromDatasetByIDsResponse } from "./data";
import type { RemoveBinaryDataFromDatasetByIDsRequest } from "./data";
import type { AddBinaryDataToDatasetByIDsResponse } from "./data";
import type { AddBinaryDataToDatasetByIDsRequest } from "./data";
import type { ConfigureDatabaseUserResponse } from "./data";
import type { ConfigureDatabaseUserRequest } from "./data";
import type { GetDatabaseConnectionResponse } from "./data";
import type { GetDatabaseConnectionRequest } from "./data";
import type { UpdateBoundingBoxResponse } from "./data";
import type { UpdateBoundingBoxRequest } from "./data";
import type { BoundingBoxLabelsByFilterResponse } from "./data";
import type { BoundingBoxLabelsByFilterRequest } from "./data";
import type { RemoveBoundingBoxFromImageByIDResponse } from "./data";
import type { RemoveBoundingBoxFromImageByIDRequest } from "./data";
import type { AddBoundingBoxToImageByIDResponse } from "./data";
import type { AddBoundingBoxToImageByIDRequest } from "./data";
import type { TagsByFilterResponse } from "./data";
import type { TagsByFilterRequest } from "./data";
import type { RemoveTagsFromBinaryDataByFilterResponse } from "./data";
import type { RemoveTagsFromBinaryDataByFilterRequest } from "./data";
import type { RemoveTagsFromBinaryDataByIDsResponse } from "./data";
import type { RemoveTagsFromBinaryDataByIDsRequest } from "./data";
import type { AddTagsToBinaryDataByFilterResponse } from "./data";
import type { AddTagsToBinaryDataByFilterRequest } from "./data";
import type { AddTagsToBinaryDataByIDsResponse } from "./data";
import type { AddTagsToBinaryDataByIDsRequest } from "./data";
import type { DeleteBinaryDataByIDsResponse } from "./data";
import type { DeleteBinaryDataByIDsRequest } from "./data";
import type { DeleteBinaryDataByFilterResponse } from "./data";
import type { DeleteBinaryDataByFilterRequest } from "./data";
import type { DeleteTabularDataResponse } from "./data";
import type { DeleteTabularDataRequest } from "./data";
import type { BinaryDataByIDsResponse } from "./data";
import type { BinaryDataByIDsRequest } from "./data";
import type { BinaryDataByFilterResponse } from "./data";
import type { BinaryDataByFilterRequest } from "./data";
import type { GetLatestTabularDataResponse } from "./data";
import type { GetLatestTabularDataRequest } from "./data";
import type { ExportTabularDataResponse } from "./data";
import type { ExportTabularDataRequest } from "./data";
import type { ServerStreamingCall } from "@protobuf-ts/runtime-rpc";
import type { TabularDataByMQLResponse } from "./data";
import type { TabularDataByMQLRequest } from "./data";
import type { TabularDataBySQLResponse } from "./data";
import type { TabularDataBySQLRequest } from "./data";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { TabularDataByFilterResponse } from "./data";
import type { TabularDataByFilterRequest } from "./data";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * DataService is used to query robot data.
 *
 * @generated from protobuf service viam.app.data.v1.DataService
 */
export interface IDataServiceClient {
    /**
     * TabularDataByFilter queries tabular data and metadata based on given filters.
     *
     * @deprecated
     * @generated from protobuf rpc: TabularDataByFilter(viam.app.data.v1.TabularDataByFilterRequest) returns (viam.app.data.v1.TabularDataByFilterResponse);
     */
    tabularDataByFilter(input: TabularDataByFilterRequest, options?: RpcOptions): UnaryCall<TabularDataByFilterRequest, TabularDataByFilterResponse>;
    /**
     * TabularDataBySQL queries tabular data with a SQL query.
     *
     * @generated from protobuf rpc: TabularDataBySQL(viam.app.data.v1.TabularDataBySQLRequest) returns (viam.app.data.v1.TabularDataBySQLResponse);
     */
    tabularDataBySQL(input: TabularDataBySQLRequest, options?: RpcOptions): UnaryCall<TabularDataBySQLRequest, TabularDataBySQLResponse>;
    /**
     * TabularDataByMQL queries tabular data with an MQL (MongoDB Query Language) query.
     *
     * @generated from protobuf rpc: TabularDataByMQL(viam.app.data.v1.TabularDataByMQLRequest) returns (viam.app.data.v1.TabularDataByMQLResponse);
     */
    tabularDataByMQL(input: TabularDataByMQLRequest, options?: RpcOptions): UnaryCall<TabularDataByMQLRequest, TabularDataByMQLResponse>;
    /**
     * ExportTabularData queries tabular data from the specified data source.
     *
     * @generated from protobuf rpc: ExportTabularData(viam.app.data.v1.ExportTabularDataRequest) returns (stream viam.app.data.v1.ExportTabularDataResponse);
     */
    exportTabularData(input: ExportTabularDataRequest, options?: RpcOptions): ServerStreamingCall<ExportTabularDataRequest, ExportTabularDataResponse>;
    /**
     * GetLatestTabularData gets the most recent tabular data captured from the specified data source.
     *
     * @generated from protobuf rpc: GetLatestTabularData(viam.app.data.v1.GetLatestTabularDataRequest) returns (viam.app.data.v1.GetLatestTabularDataResponse);
     */
    getLatestTabularData(input: GetLatestTabularDataRequest, options?: RpcOptions): UnaryCall<GetLatestTabularDataRequest, GetLatestTabularDataResponse>;
    /**
     * BinaryDataByFilter queries binary data and metadata based on given filters.
     *
     * @generated from protobuf rpc: BinaryDataByFilter(viam.app.data.v1.BinaryDataByFilterRequest) returns (viam.app.data.v1.BinaryDataByFilterResponse);
     */
    binaryDataByFilter(input: BinaryDataByFilterRequest, options?: RpcOptions): UnaryCall<BinaryDataByFilterRequest, BinaryDataByFilterResponse>;
    /**
     * BinaryDataByIDs queries binary data and metadata based on given IDs.
     *
     * @generated from protobuf rpc: BinaryDataByIDs(viam.app.data.v1.BinaryDataByIDsRequest) returns (viam.app.data.v1.BinaryDataByIDsResponse);
     */
    binaryDataByIDs(input: BinaryDataByIDsRequest, options?: RpcOptions): UnaryCall<BinaryDataByIDsRequest, BinaryDataByIDsResponse>;
    /**
     * DeleteTabularData deletes tabular data older than a number of days, based on the given organization ID.
     *
     * @generated from protobuf rpc: DeleteTabularData(viam.app.data.v1.DeleteTabularDataRequest) returns (viam.app.data.v1.DeleteTabularDataResponse);
     */
    deleteTabularData(input: DeleteTabularDataRequest, options?: RpcOptions): UnaryCall<DeleteTabularDataRequest, DeleteTabularDataResponse>;
    /**
     * DeleteBinaryDataByFilter deletes binary data based on given filters.
     *
     * @generated from protobuf rpc: DeleteBinaryDataByFilter(viam.app.data.v1.DeleteBinaryDataByFilterRequest) returns (viam.app.data.v1.DeleteBinaryDataByFilterResponse);
     */
    deleteBinaryDataByFilter(input: DeleteBinaryDataByFilterRequest, options?: RpcOptions): UnaryCall<DeleteBinaryDataByFilterRequest, DeleteBinaryDataByFilterResponse>;
    /**
     * DeleteBinaryDataByIDs deletes binary data based on given IDs.
     *
     * @generated from protobuf rpc: DeleteBinaryDataByIDs(viam.app.data.v1.DeleteBinaryDataByIDsRequest) returns (viam.app.data.v1.DeleteBinaryDataByIDsResponse);
     */
    deleteBinaryDataByIDs(input: DeleteBinaryDataByIDsRequest, options?: RpcOptions): UnaryCall<DeleteBinaryDataByIDsRequest, DeleteBinaryDataByIDsResponse>;
    /**
     * AddTagsToBinaryDataByIDs adds string tags, unless the tags are already present, to binary data based on given IDs.
     *
     * @generated from protobuf rpc: AddTagsToBinaryDataByIDs(viam.app.data.v1.AddTagsToBinaryDataByIDsRequest) returns (viam.app.data.v1.AddTagsToBinaryDataByIDsResponse);
     */
    addTagsToBinaryDataByIDs(input: AddTagsToBinaryDataByIDsRequest, options?: RpcOptions): UnaryCall<AddTagsToBinaryDataByIDsRequest, AddTagsToBinaryDataByIDsResponse>;
    /**
     * AddTagsToBinaryDataByFilter adds string tags, unless the tags are already present, to binary data based on the given filter.
     *
     * @deprecated
     * @generated from protobuf rpc: AddTagsToBinaryDataByFilter(viam.app.data.v1.AddTagsToBinaryDataByFilterRequest) returns (viam.app.data.v1.AddTagsToBinaryDataByFilterResponse);
     */
    addTagsToBinaryDataByFilter(input: AddTagsToBinaryDataByFilterRequest, options?: RpcOptions): UnaryCall<AddTagsToBinaryDataByFilterRequest, AddTagsToBinaryDataByFilterResponse>;
    /**
     * RemoveTagsToBinaryDataByIDs removes string tags from binary data based on given IDs.
     *
     * @generated from protobuf rpc: RemoveTagsFromBinaryDataByIDs(viam.app.data.v1.RemoveTagsFromBinaryDataByIDsRequest) returns (viam.app.data.v1.RemoveTagsFromBinaryDataByIDsResponse);
     */
    removeTagsFromBinaryDataByIDs(input: RemoveTagsFromBinaryDataByIDsRequest, options?: RpcOptions): UnaryCall<RemoveTagsFromBinaryDataByIDsRequest, RemoveTagsFromBinaryDataByIDsResponse>;
    /**
     * RemoveTagsToBinaryDataByFilter removes string tags from binary data based on the given filter.
     *
     * @deprecated
     * @generated from protobuf rpc: RemoveTagsFromBinaryDataByFilter(viam.app.data.v1.RemoveTagsFromBinaryDataByFilterRequest) returns (viam.app.data.v1.RemoveTagsFromBinaryDataByFilterResponse);
     */
    removeTagsFromBinaryDataByFilter(input: RemoveTagsFromBinaryDataByFilterRequest, options?: RpcOptions): UnaryCall<RemoveTagsFromBinaryDataByFilterRequest, RemoveTagsFromBinaryDataByFilterResponse>;
    /**
     * TagsByFilter gets all unique tags from data based on given filter.
     *
     * @deprecated
     * @generated from protobuf rpc: TagsByFilter(viam.app.data.v1.TagsByFilterRequest) returns (viam.app.data.v1.TagsByFilterResponse);
     */
    tagsByFilter(input: TagsByFilterRequest, options?: RpcOptions): UnaryCall<TagsByFilterRequest, TagsByFilterResponse>;
    /**
     * AddBoundingBoxToImageByID adds a bounding box to an image with the given ID.
     *
     * @generated from protobuf rpc: AddBoundingBoxToImageByID(viam.app.data.v1.AddBoundingBoxToImageByIDRequest) returns (viam.app.data.v1.AddBoundingBoxToImageByIDResponse);
     */
    addBoundingBoxToImageByID(input: AddBoundingBoxToImageByIDRequest, options?: RpcOptions): UnaryCall<AddBoundingBoxToImageByIDRequest, AddBoundingBoxToImageByIDResponse>;
    /**
     * RemoveBoundingBoxFromImageByID removes a bounding box from an image with the given ID.
     *
     * @generated from protobuf rpc: RemoveBoundingBoxFromImageByID(viam.app.data.v1.RemoveBoundingBoxFromImageByIDRequest) returns (viam.app.data.v1.RemoveBoundingBoxFromImageByIDResponse);
     */
    removeBoundingBoxFromImageByID(input: RemoveBoundingBoxFromImageByIDRequest, options?: RpcOptions): UnaryCall<RemoveBoundingBoxFromImageByIDRequest, RemoveBoundingBoxFromImageByIDResponse>;
    /**
     * BoundingBoxLabelsByFilter gets all string labels for bounding boxes from data based on given filter.
     *
     * @deprecated
     * @generated from protobuf rpc: BoundingBoxLabelsByFilter(viam.app.data.v1.BoundingBoxLabelsByFilterRequest) returns (viam.app.data.v1.BoundingBoxLabelsByFilterResponse);
     */
    boundingBoxLabelsByFilter(input: BoundingBoxLabelsByFilterRequest, options?: RpcOptions): UnaryCall<BoundingBoxLabelsByFilterRequest, BoundingBoxLabelsByFilterResponse>;
    /**
     * UpdateBoundingBox updates the bounding box associated with a given binary ID and bounding box ID.
     *
     * @generated from protobuf rpc: UpdateBoundingBox(viam.app.data.v1.UpdateBoundingBoxRequest) returns (viam.app.data.v1.UpdateBoundingBoxResponse);
     */
    updateBoundingBox(input: UpdateBoundingBoxRequest, options?: RpcOptions): UnaryCall<UpdateBoundingBoxRequest, UpdateBoundingBoxResponse>;
    /**
     * GetDatabaseConnection gets a connection to access a MongoDB Atlas Data Federation instance. It
     * returns the hostname of the federated database.
     *
     * @generated from protobuf rpc: GetDatabaseConnection(viam.app.data.v1.GetDatabaseConnectionRequest) returns (viam.app.data.v1.GetDatabaseConnectionResponse);
     */
    getDatabaseConnection(input: GetDatabaseConnectionRequest, options?: RpcOptions): UnaryCall<GetDatabaseConnectionRequest, GetDatabaseConnectionResponse>;
    /**
     * ConfigureDatabaseUser configures a database user for the Viam organization's MongoDB Atlas Data
     * Federation instance. It can also be used to reset the password of the existing database user.
     *
     * @generated from protobuf rpc: ConfigureDatabaseUser(viam.app.data.v1.ConfigureDatabaseUserRequest) returns (viam.app.data.v1.ConfigureDatabaseUserResponse);
     */
    configureDatabaseUser(input: ConfigureDatabaseUserRequest, options?: RpcOptions): UnaryCall<ConfigureDatabaseUserRequest, ConfigureDatabaseUserResponse>;
    /**
     * AddBinaryDataToDatasetByIDs adds the binary data with the given binary IDs to the dataset.
     *
     * @generated from protobuf rpc: AddBinaryDataToDatasetByIDs(viam.app.data.v1.AddBinaryDataToDatasetByIDsRequest) returns (viam.app.data.v1.AddBinaryDataToDatasetByIDsResponse);
     */
    addBinaryDataToDatasetByIDs(input: AddBinaryDataToDatasetByIDsRequest, options?: RpcOptions): UnaryCall<AddBinaryDataToDatasetByIDsRequest, AddBinaryDataToDatasetByIDsResponse>;
    /**
     * RemoveBinaryDataFromDatasetByIDs removes the binary data with the given binary IDs from the dataset.
     *
     * @generated from protobuf rpc: RemoveBinaryDataFromDatasetByIDs(viam.app.data.v1.RemoveBinaryDataFromDatasetByIDsRequest) returns (viam.app.data.v1.RemoveBinaryDataFromDatasetByIDsResponse);
     */
    removeBinaryDataFromDatasetByIDs(input: RemoveBinaryDataFromDatasetByIDsRequest, options?: RpcOptions): UnaryCall<RemoveBinaryDataFromDatasetByIDsRequest, RemoveBinaryDataFromDatasetByIDsResponse>;
    /**
     * AddSequencesToDataset adds the sequences with the given IDs to the dataset.
     *
     * @generated from protobuf rpc: AddSequencesToDataset(viam.app.data.v1.AddSequencesToDatasetRequest) returns (viam.app.data.v1.AddSequencesToDatasetResponse);
     */
    addSequencesToDataset(input: AddSequencesToDatasetRequest, options?: RpcOptions): UnaryCall<AddSequencesToDatasetRequest, AddSequencesToDatasetResponse>;
    /**
     * RemoveSequencesFromDataset removes the sequences with the given IDs from the dataset.
     *
     * @generated from protobuf rpc: RemoveSequencesFromDataset(viam.app.data.v1.RemoveSequencesFromDatasetRequest) returns (viam.app.data.v1.RemoveSequencesFromDatasetResponse);
     */
    removeSequencesFromDataset(input: RemoveSequencesFromDatasetRequest, options?: RpcOptions): UnaryCall<RemoveSequencesFromDatasetRequest, RemoveSequencesFromDatasetResponse>;
    /**
     * CreateIndex starts a custom index build
     *
     * @generated from protobuf rpc: CreateIndex(viam.app.data.v1.CreateIndexRequest) returns (viam.app.data.v1.CreateIndexResponse);
     */
    createIndex(input: CreateIndexRequest, options?: RpcOptions): UnaryCall<CreateIndexRequest, CreateIndexResponse>;
    /**
     * ListIndexes returns all the indexes for a given collection
     *
     * @generated from protobuf rpc: ListIndexes(viam.app.data.v1.ListIndexesRequest) returns (viam.app.data.v1.ListIndexesResponse);
     */
    listIndexes(input: ListIndexesRequest, options?: RpcOptions): UnaryCall<ListIndexesRequest, ListIndexesResponse>;
    /**
     * DeleteIndex drops the specified custom index from a collection
     *
     * @generated from protobuf rpc: DeleteIndex(viam.app.data.v1.DeleteIndexRequest) returns (viam.app.data.v1.DeleteIndexResponse);
     */
    deleteIndex(input: DeleteIndexRequest, options?: RpcOptions): UnaryCall<DeleteIndexRequest, DeleteIndexResponse>;
    /**
     * CreateSavedQuery saves a mql query.
     *
     * @generated from protobuf rpc: CreateSavedQuery(viam.app.data.v1.CreateSavedQueryRequest) returns (viam.app.data.v1.CreateSavedQueryResponse);
     */
    createSavedQuery(input: CreateSavedQueryRequest, options?: RpcOptions): UnaryCall<CreateSavedQueryRequest, CreateSavedQueryResponse>;
    /**
     * UpdateSavedQuery updates the saved query with the given id.
     *
     * @generated from protobuf rpc: UpdateSavedQuery(viam.app.data.v1.UpdateSavedQueryRequest) returns (viam.app.data.v1.UpdateSavedQueryResponse);
     */
    updateSavedQuery(input: UpdateSavedQueryRequest, options?: RpcOptions): UnaryCall<UpdateSavedQueryRequest, UpdateSavedQueryResponse>;
    /**
     * GetSavedQuery retrieves a saved query by id.
     *
     * @generated from protobuf rpc: GetSavedQuery(viam.app.data.v1.GetSavedQueryRequest) returns (viam.app.data.v1.GetSavedQueryResponse);
     */
    getSavedQuery(input: GetSavedQueryRequest, options?: RpcOptions): UnaryCall<GetSavedQueryRequest, GetSavedQueryResponse>;
    /**
     * DeleteSavedQuery deletes a saved query based on the given id.
     *
     * @generated from protobuf rpc: DeleteSavedQuery(viam.app.data.v1.DeleteSavedQueryRequest) returns (viam.app.data.v1.DeleteSavedQueryResponse);
     */
    deleteSavedQuery(input: DeleteSavedQueryRequest, options?: RpcOptions): UnaryCall<DeleteSavedQueryRequest, DeleteSavedQueryResponse>;
    /**
     * ListSavedQueries lists saved queries for a given organization.
     *
     * @generated from protobuf rpc: ListSavedQueries(viam.app.data.v1.ListSavedQueriesRequest) returns (viam.app.data.v1.ListSavedQueriesResponse);
     */
    listSavedQueries(input: ListSavedQueriesRequest, options?: RpcOptions): UnaryCall<ListSavedQueriesRequest, ListSavedQueriesResponse>;
    /**
     * CreateBinaryDataSignedURL creates a temporary public URL for a binary data file.
     *
     * @generated from protobuf rpc: CreateBinaryDataSignedURL(viam.app.data.v1.CreateBinaryDataSignedURLRequest) returns (viam.app.data.v1.CreateBinaryDataSignedURLResponse);
     */
    createBinaryDataSignedURL(input: CreateBinaryDataSignedURLRequest, options?: RpcOptions): UnaryCall<CreateBinaryDataSignedURLRequest, CreateBinaryDataSignedURLResponse>;
    /**
     * CreateSequence creates a new sequence.
     *
     * @generated from protobuf rpc: CreateSequence(viam.app.data.v1.CreateSequenceRequest) returns (viam.app.data.v1.CreateSequenceResponse);
     */
    createSequence(input: CreateSequenceRequest, options?: RpcOptions): UnaryCall<CreateSequenceRequest, CreateSequenceResponse>;
    /**
     * GetSequence retrieves a sequence by ID.
     *
     * @generated from protobuf rpc: GetSequence(viam.app.data.v1.GetSequenceRequest) returns (viam.app.data.v1.GetSequenceResponse);
     */
    getSequence(input: GetSequenceRequest, options?: RpcOptions): UnaryCall<GetSequenceRequest, GetSequenceResponse>;
    /**
     * UpdateSequence updates the mutable fields of a sequence.
     *
     * @generated from protobuf rpc: UpdateSequence(viam.app.data.v1.UpdateSequenceRequest) returns (viam.app.data.v1.UpdateSequenceResponse);
     */
    updateSequence(input: UpdateSequenceRequest, options?: RpcOptions): UnaryCall<UpdateSequenceRequest, UpdateSequenceResponse>;
    /**
     * DeleteSequence deletes a sequence by ID.
     *
     * @generated from protobuf rpc: DeleteSequence(viam.app.data.v1.DeleteSequenceRequest) returns (viam.app.data.v1.DeleteSequenceResponse);
     */
    deleteSequence(input: DeleteSequenceRequest, options?: RpcOptions): UnaryCall<DeleteSequenceRequest, DeleteSequenceResponse>;
    /**
     * ListSequences lists sequences for a given organization.
     *
     * @generated from protobuf rpc: ListSequences(viam.app.data.v1.ListSequencesRequest) returns (viam.app.data.v1.ListSequencesResponse);
     */
    listSequences(input: ListSequencesRequest, options?: RpcOptions): UnaryCall<ListSequencesRequest, ListSequencesResponse>;
    /**
     * SequencesByDatasetID lists sequences that belong to the given dataset.
     *
     * @generated from protobuf rpc: SequencesByDatasetID(viam.app.data.v1.SequencesByDatasetIDRequest) returns (viam.app.data.v1.SequencesByDatasetIDResponse);
     */
    sequencesByDatasetID(input: SequencesByDatasetIDRequest, options?: RpcOptions): UnaryCall<SequencesByDatasetIDRequest, SequencesByDatasetIDResponse>;
    /**
     * GetSequenceBinaryData returns paginated binary data records matching the
     * sequence's time range and binary resources.
     *
     * @generated from protobuf rpc: GetSequenceBinaryData(viam.app.data.v1.GetSequenceBinaryDataRequest) returns (viam.app.data.v1.GetSequenceBinaryDataResponse);
     */
    getSequenceBinaryData(input: GetSequenceBinaryDataRequest, options?: RpcOptions): UnaryCall<GetSequenceBinaryDataRequest, GetSequenceBinaryDataResponse>;
}
/**
 * DataService is used to query robot data.
 *
 * @generated from protobuf service viam.app.data.v1.DataService
 */
export class DataServiceClient implements IDataServiceClient, ServiceInfo {
    typeName = DataService.typeName;
    methods = DataService.methods;
    options = DataService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * TabularDataByFilter queries tabular data and metadata based on given filters.
     *
     * @deprecated
     * @generated from protobuf rpc: TabularDataByFilter(viam.app.data.v1.TabularDataByFilterRequest) returns (viam.app.data.v1.TabularDataByFilterResponse);
     */
    tabularDataByFilter(input: TabularDataByFilterRequest, options?: RpcOptions): UnaryCall<TabularDataByFilterRequest, TabularDataByFilterResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<TabularDataByFilterRequest, TabularDataByFilterResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * TabularDataBySQL queries tabular data with a SQL query.
     *
     * @generated from protobuf rpc: TabularDataBySQL(viam.app.data.v1.TabularDataBySQLRequest) returns (viam.app.data.v1.TabularDataBySQLResponse);
     */
    tabularDataBySQL(input: TabularDataBySQLRequest, options?: RpcOptions): UnaryCall<TabularDataBySQLRequest, TabularDataBySQLResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<TabularDataBySQLRequest, TabularDataBySQLResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * TabularDataByMQL queries tabular data with an MQL (MongoDB Query Language) query.
     *
     * @generated from protobuf rpc: TabularDataByMQL(viam.app.data.v1.TabularDataByMQLRequest) returns (viam.app.data.v1.TabularDataByMQLResponse);
     */
    tabularDataByMQL(input: TabularDataByMQLRequest, options?: RpcOptions): UnaryCall<TabularDataByMQLRequest, TabularDataByMQLResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<TabularDataByMQLRequest, TabularDataByMQLResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * ExportTabularData queries tabular data from the specified data source.
     *
     * @generated from protobuf rpc: ExportTabularData(viam.app.data.v1.ExportTabularDataRequest) returns (stream viam.app.data.v1.ExportTabularDataResponse);
     */
    exportTabularData(input: ExportTabularDataRequest, options?: RpcOptions): ServerStreamingCall<ExportTabularDataRequest, ExportTabularDataResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<ExportTabularDataRequest, ExportTabularDataResponse>("serverStreaming", this._transport, method, opt, input);
    }
    /**
     * GetLatestTabularData gets the most recent tabular data captured from the specified data source.
     *
     * @generated from protobuf rpc: GetLatestTabularData(viam.app.data.v1.GetLatestTabularDataRequest) returns (viam.app.data.v1.GetLatestTabularDataResponse);
     */
    getLatestTabularData(input: GetLatestTabularDataRequest, options?: RpcOptions): UnaryCall<GetLatestTabularDataRequest, GetLatestTabularDataResponse> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetLatestTabularDataRequest, GetLatestTabularDataResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * BinaryDataByFilter queries binary data and metadata based on given filters.
     *
     * @generated from protobuf rpc: BinaryDataByFilter(viam.app.data.v1.BinaryDataByFilterRequest) returns (viam.app.data.v1.BinaryDataByFilterResponse);
     */
    binaryDataByFilter(input: BinaryDataByFilterRequest, options?: RpcOptions): UnaryCall<BinaryDataByFilterRequest, BinaryDataByFilterResponse> {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept<BinaryDataByFilterRequest, BinaryDataByFilterResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * BinaryDataByIDs queries binary data and metadata based on given IDs.
     *
     * @generated from protobuf rpc: BinaryDataByIDs(viam.app.data.v1.BinaryDataByIDsRequest) returns (viam.app.data.v1.BinaryDataByIDsResponse);
     */
    binaryDataByIDs(input: BinaryDataByIDsRequest, options?: RpcOptions): UnaryCall<BinaryDataByIDsRequest, BinaryDataByIDsResponse> {
        const method = this.methods[6], opt = this._transport.mergeOptions(options);
        return stackIntercept<BinaryDataByIDsRequest, BinaryDataByIDsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * DeleteTabularData deletes tabular data older than a number of days, based on the given organization ID.
     *
     * @generated from protobuf rpc: DeleteTabularData(viam.app.data.v1.DeleteTabularDataRequest) returns (viam.app.data.v1.DeleteTabularDataResponse);
     */
    deleteTabularData(input: DeleteTabularDataRequest, options?: RpcOptions): UnaryCall<DeleteTabularDataRequest, DeleteTabularDataResponse> {
        const method = this.methods[7], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeleteTabularDataRequest, DeleteTabularDataResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * DeleteBinaryDataByFilter deletes binary data based on given filters.
     *
     * @generated from protobuf rpc: DeleteBinaryDataByFilter(viam.app.data.v1.DeleteBinaryDataByFilterRequest) returns (viam.app.data.v1.DeleteBinaryDataByFilterResponse);
     */
    deleteBinaryDataByFilter(input: DeleteBinaryDataByFilterRequest, options?: RpcOptions): UnaryCall<DeleteBinaryDataByFilterRequest, DeleteBinaryDataByFilterResponse> {
        const method = this.methods[8], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeleteBinaryDataByFilterRequest, DeleteBinaryDataByFilterResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * DeleteBinaryDataByIDs deletes binary data based on given IDs.
     *
     * @generated from protobuf rpc: DeleteBinaryDataByIDs(viam.app.data.v1.DeleteBinaryDataByIDsRequest) returns (viam.app.data.v1.DeleteBinaryDataByIDsResponse);
     */
    deleteBinaryDataByIDs(input: DeleteBinaryDataByIDsRequest, options?: RpcOptions): UnaryCall<DeleteBinaryDataByIDsRequest, DeleteBinaryDataByIDsResponse> {
        const method = this.methods[9], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeleteBinaryDataByIDsRequest, DeleteBinaryDataByIDsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * AddTagsToBinaryDataByIDs adds string tags, unless the tags are already present, to binary data based on given IDs.
     *
     * @generated from protobuf rpc: AddTagsToBinaryDataByIDs(viam.app.data.v1.AddTagsToBinaryDataByIDsRequest) returns (viam.app.data.v1.AddTagsToBinaryDataByIDsResponse);
     */
    addTagsToBinaryDataByIDs(input: AddTagsToBinaryDataByIDsRequest, options?: RpcOptions): UnaryCall<AddTagsToBinaryDataByIDsRequest, AddTagsToBinaryDataByIDsResponse> {
        const method = this.methods[10], opt = this._transport.mergeOptions(options);
        return stackIntercept<AddTagsToBinaryDataByIDsRequest, AddTagsToBinaryDataByIDsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * AddTagsToBinaryDataByFilter adds string tags, unless the tags are already present, to binary data based on the given filter.
     *
     * @deprecated
     * @generated from protobuf rpc: AddTagsToBinaryDataByFilter(viam.app.data.v1.AddTagsToBinaryDataByFilterRequest) returns (viam.app.data.v1.AddTagsToBinaryDataByFilterResponse);
     */
    addTagsToBinaryDataByFilter(input: AddTagsToBinaryDataByFilterRequest, options?: RpcOptions): UnaryCall<AddTagsToBinaryDataByFilterRequest, AddTagsToBinaryDataByFilterResponse> {
        const method = this.methods[11], opt = this._transport.mergeOptions(options);
        return stackIntercept<AddTagsToBinaryDataByFilterRequest, AddTagsToBinaryDataByFilterResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * RemoveTagsToBinaryDataByIDs removes string tags from binary data based on given IDs.
     *
     * @generated from protobuf rpc: RemoveTagsFromBinaryDataByIDs(viam.app.data.v1.RemoveTagsFromBinaryDataByIDsRequest) returns (viam.app.data.v1.RemoveTagsFromBinaryDataByIDsResponse);
     */
    removeTagsFromBinaryDataByIDs(input: RemoveTagsFromBinaryDataByIDsRequest, options?: RpcOptions): UnaryCall<RemoveTagsFromBinaryDataByIDsRequest, RemoveTagsFromBinaryDataByIDsResponse> {
        const method = this.methods[12], opt = this._transport.mergeOptions(options);
        return stackIntercept<RemoveTagsFromBinaryDataByIDsRequest, RemoveTagsFromBinaryDataByIDsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * RemoveTagsToBinaryDataByFilter removes string tags from binary data based on the given filter.
     *
     * @deprecated
     * @generated from protobuf rpc: RemoveTagsFromBinaryDataByFilter(viam.app.data.v1.RemoveTagsFromBinaryDataByFilterRequest) returns (viam.app.data.v1.RemoveTagsFromBinaryDataByFilterResponse);
     */
    removeTagsFromBinaryDataByFilter(input: RemoveTagsFromBinaryDataByFilterRequest, options?: RpcOptions): UnaryCall<RemoveTagsFromBinaryDataByFilterRequest, RemoveTagsFromBinaryDataByFilterResponse> {
        const method = this.methods[13], opt = this._transport.mergeOptions(options);
        return stackIntercept<RemoveTagsFromBinaryDataByFilterRequest, RemoveTagsFromBinaryDataByFilterResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * TagsByFilter gets all unique tags from data based on given filter.
     *
     * @deprecated
     * @generated from protobuf rpc: TagsByFilter(viam.app.data.v1.TagsByFilterRequest) returns (viam.app.data.v1.TagsByFilterResponse);
     */
    tagsByFilter(input: TagsByFilterRequest, options?: RpcOptions): UnaryCall<TagsByFilterRequest, TagsByFilterResponse> {
        const method = this.methods[14], opt = this._transport.mergeOptions(options);
        return stackIntercept<TagsByFilterRequest, TagsByFilterResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * AddBoundingBoxToImageByID adds a bounding box to an image with the given ID.
     *
     * @generated from protobuf rpc: AddBoundingBoxToImageByID(viam.app.data.v1.AddBoundingBoxToImageByIDRequest) returns (viam.app.data.v1.AddBoundingBoxToImageByIDResponse);
     */
    addBoundingBoxToImageByID(input: AddBoundingBoxToImageByIDRequest, options?: RpcOptions): UnaryCall<AddBoundingBoxToImageByIDRequest, AddBoundingBoxToImageByIDResponse> {
        const method = this.methods[15], opt = this._transport.mergeOptions(options);
        return stackIntercept<AddBoundingBoxToImageByIDRequest, AddBoundingBoxToImageByIDResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * RemoveBoundingBoxFromImageByID removes a bounding box from an image with the given ID.
     *
     * @generated from protobuf rpc: RemoveBoundingBoxFromImageByID(viam.app.data.v1.RemoveBoundingBoxFromImageByIDRequest) returns (viam.app.data.v1.RemoveBoundingBoxFromImageByIDResponse);
     */
    removeBoundingBoxFromImageByID(input: RemoveBoundingBoxFromImageByIDRequest, options?: RpcOptions): UnaryCall<RemoveBoundingBoxFromImageByIDRequest, RemoveBoundingBoxFromImageByIDResponse> {
        const method = this.methods[16], opt = this._transport.mergeOptions(options);
        return stackIntercept<RemoveBoundingBoxFromImageByIDRequest, RemoveBoundingBoxFromImageByIDResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * BoundingBoxLabelsByFilter gets all string labels for bounding boxes from data based on given filter.
     *
     * @deprecated
     * @generated from protobuf rpc: BoundingBoxLabelsByFilter(viam.app.data.v1.BoundingBoxLabelsByFilterRequest) returns (viam.app.data.v1.BoundingBoxLabelsByFilterResponse);
     */
    boundingBoxLabelsByFilter(input: BoundingBoxLabelsByFilterRequest, options?: RpcOptions): UnaryCall<BoundingBoxLabelsByFilterRequest, BoundingBoxLabelsByFilterResponse> {
        const method = this.methods[17], opt = this._transport.mergeOptions(options);
        return stackIntercept<BoundingBoxLabelsByFilterRequest, BoundingBoxLabelsByFilterResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * UpdateBoundingBox updates the bounding box associated with a given binary ID and bounding box ID.
     *
     * @generated from protobuf rpc: UpdateBoundingBox(viam.app.data.v1.UpdateBoundingBoxRequest) returns (viam.app.data.v1.UpdateBoundingBoxResponse);
     */
    updateBoundingBox(input: UpdateBoundingBoxRequest, options?: RpcOptions): UnaryCall<UpdateBoundingBoxRequest, UpdateBoundingBoxResponse> {
        const method = this.methods[18], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateBoundingBoxRequest, UpdateBoundingBoxResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * GetDatabaseConnection gets a connection to access a MongoDB Atlas Data Federation instance. It
     * returns the hostname of the federated database.
     *
     * @generated from protobuf rpc: GetDatabaseConnection(viam.app.data.v1.GetDatabaseConnectionRequest) returns (viam.app.data.v1.GetDatabaseConnectionResponse);
     */
    getDatabaseConnection(input: GetDatabaseConnectionRequest, options?: RpcOptions): UnaryCall<GetDatabaseConnectionRequest, GetDatabaseConnectionResponse> {
        const method = this.methods[19], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetDatabaseConnectionRequest, GetDatabaseConnectionResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * ConfigureDatabaseUser configures a database user for the Viam organization's MongoDB Atlas Data
     * Federation instance. It can also be used to reset the password of the existing database user.
     *
     * @generated from protobuf rpc: ConfigureDatabaseUser(viam.app.data.v1.ConfigureDatabaseUserRequest) returns (viam.app.data.v1.ConfigureDatabaseUserResponse);
     */
    configureDatabaseUser(input: ConfigureDatabaseUserRequest, options?: RpcOptions): UnaryCall<ConfigureDatabaseUserRequest, ConfigureDatabaseUserResponse> {
        const method = this.methods[20], opt = this._transport.mergeOptions(options);
        return stackIntercept<ConfigureDatabaseUserRequest, ConfigureDatabaseUserResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * AddBinaryDataToDatasetByIDs adds the binary data with the given binary IDs to the dataset.
     *
     * @generated from protobuf rpc: AddBinaryDataToDatasetByIDs(viam.app.data.v1.AddBinaryDataToDatasetByIDsRequest) returns (viam.app.data.v1.AddBinaryDataToDatasetByIDsResponse);
     */
    addBinaryDataToDatasetByIDs(input: AddBinaryDataToDatasetByIDsRequest, options?: RpcOptions): UnaryCall<AddBinaryDataToDatasetByIDsRequest, AddBinaryDataToDatasetByIDsResponse> {
        const method = this.methods[21], opt = this._transport.mergeOptions(options);
        return stackIntercept<AddBinaryDataToDatasetByIDsRequest, AddBinaryDataToDatasetByIDsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * RemoveBinaryDataFromDatasetByIDs removes the binary data with the given binary IDs from the dataset.
     *
     * @generated from protobuf rpc: RemoveBinaryDataFromDatasetByIDs(viam.app.data.v1.RemoveBinaryDataFromDatasetByIDsRequest) returns (viam.app.data.v1.RemoveBinaryDataFromDatasetByIDsResponse);
     */
    removeBinaryDataFromDatasetByIDs(input: RemoveBinaryDataFromDatasetByIDsRequest, options?: RpcOptions): UnaryCall<RemoveBinaryDataFromDatasetByIDsRequest, RemoveBinaryDataFromDatasetByIDsResponse> {
        const method = this.methods[22], opt = this._transport.mergeOptions(options);
        return stackIntercept<RemoveBinaryDataFromDatasetByIDsRequest, RemoveBinaryDataFromDatasetByIDsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * AddSequencesToDataset adds the sequences with the given IDs to the dataset.
     *
     * @generated from protobuf rpc: AddSequencesToDataset(viam.app.data.v1.AddSequencesToDatasetRequest) returns (viam.app.data.v1.AddSequencesToDatasetResponse);
     */
    addSequencesToDataset(input: AddSequencesToDatasetRequest, options?: RpcOptions): UnaryCall<AddSequencesToDatasetRequest, AddSequencesToDatasetResponse> {
        const method = this.methods[23], opt = this._transport.mergeOptions(options);
        return stackIntercept<AddSequencesToDatasetRequest, AddSequencesToDatasetResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * RemoveSequencesFromDataset removes the sequences with the given IDs from the dataset.
     *
     * @generated from protobuf rpc: RemoveSequencesFromDataset(viam.app.data.v1.RemoveSequencesFromDatasetRequest) returns (viam.app.data.v1.RemoveSequencesFromDatasetResponse);
     */
    removeSequencesFromDataset(input: RemoveSequencesFromDatasetRequest, options?: RpcOptions): UnaryCall<RemoveSequencesFromDatasetRequest, RemoveSequencesFromDatasetResponse> {
        const method = this.methods[24], opt = this._transport.mergeOptions(options);
        return stackIntercept<RemoveSequencesFromDatasetRequest, RemoveSequencesFromDatasetResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * CreateIndex starts a custom index build
     *
     * @generated from protobuf rpc: CreateIndex(viam.app.data.v1.CreateIndexRequest) returns (viam.app.data.v1.CreateIndexResponse);
     */
    createIndex(input: CreateIndexRequest, options?: RpcOptions): UnaryCall<CreateIndexRequest, CreateIndexResponse> {
        const method = this.methods[25], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateIndexRequest, CreateIndexResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * ListIndexes returns all the indexes for a given collection
     *
     * @generated from protobuf rpc: ListIndexes(viam.app.data.v1.ListIndexesRequest) returns (viam.app.data.v1.ListIndexesResponse);
     */
    listIndexes(input: ListIndexesRequest, options?: RpcOptions): UnaryCall<ListIndexesRequest, ListIndexesResponse> {
        const method = this.methods[26], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListIndexesRequest, ListIndexesResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * DeleteIndex drops the specified custom index from a collection
     *
     * @generated from protobuf rpc: DeleteIndex(viam.app.data.v1.DeleteIndexRequest) returns (viam.app.data.v1.DeleteIndexResponse);
     */
    deleteIndex(input: DeleteIndexRequest, options?: RpcOptions): UnaryCall<DeleteIndexRequest, DeleteIndexResponse> {
        const method = this.methods[27], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeleteIndexRequest, DeleteIndexResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * CreateSavedQuery saves a mql query.
     *
     * @generated from protobuf rpc: CreateSavedQuery(viam.app.data.v1.CreateSavedQueryRequest) returns (viam.app.data.v1.CreateSavedQueryResponse);
     */
    createSavedQuery(input: CreateSavedQueryRequest, options?: RpcOptions): UnaryCall<CreateSavedQueryRequest, CreateSavedQueryResponse> {
        const method = this.methods[28], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateSavedQueryRequest, CreateSavedQueryResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * UpdateSavedQuery updates the saved query with the given id.
     *
     * @generated from protobuf rpc: UpdateSavedQuery(viam.app.data.v1.UpdateSavedQueryRequest) returns (viam.app.data.v1.UpdateSavedQueryResponse);
     */
    updateSavedQuery(input: UpdateSavedQueryRequest, options?: RpcOptions): UnaryCall<UpdateSavedQueryRequest, UpdateSavedQueryResponse> {
        const method = this.methods[29], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateSavedQueryRequest, UpdateSavedQueryResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * GetSavedQuery retrieves a saved query by id.
     *
     * @generated from protobuf rpc: GetSavedQuery(viam.app.data.v1.GetSavedQueryRequest) returns (viam.app.data.v1.GetSavedQueryResponse);
     */
    getSavedQuery(input: GetSavedQueryRequest, options?: RpcOptions): UnaryCall<GetSavedQueryRequest, GetSavedQueryResponse> {
        const method = this.methods[30], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetSavedQueryRequest, GetSavedQueryResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * DeleteSavedQuery deletes a saved query based on the given id.
     *
     * @generated from protobuf rpc: DeleteSavedQuery(viam.app.data.v1.DeleteSavedQueryRequest) returns (viam.app.data.v1.DeleteSavedQueryResponse);
     */
    deleteSavedQuery(input: DeleteSavedQueryRequest, options?: RpcOptions): UnaryCall<DeleteSavedQueryRequest, DeleteSavedQueryResponse> {
        const method = this.methods[31], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeleteSavedQueryRequest, DeleteSavedQueryResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * ListSavedQueries lists saved queries for a given organization.
     *
     * @generated from protobuf rpc: ListSavedQueries(viam.app.data.v1.ListSavedQueriesRequest) returns (viam.app.data.v1.ListSavedQueriesResponse);
     */
    listSavedQueries(input: ListSavedQueriesRequest, options?: RpcOptions): UnaryCall<ListSavedQueriesRequest, ListSavedQueriesResponse> {
        const method = this.methods[32], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListSavedQueriesRequest, ListSavedQueriesResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * CreateBinaryDataSignedURL creates a temporary public URL for a binary data file.
     *
     * @generated from protobuf rpc: CreateBinaryDataSignedURL(viam.app.data.v1.CreateBinaryDataSignedURLRequest) returns (viam.app.data.v1.CreateBinaryDataSignedURLResponse);
     */
    createBinaryDataSignedURL(input: CreateBinaryDataSignedURLRequest, options?: RpcOptions): UnaryCall<CreateBinaryDataSignedURLRequest, CreateBinaryDataSignedURLResponse> {
        const method = this.methods[33], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateBinaryDataSignedURLRequest, CreateBinaryDataSignedURLResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * CreateSequence creates a new sequence.
     *
     * @generated from protobuf rpc: CreateSequence(viam.app.data.v1.CreateSequenceRequest) returns (viam.app.data.v1.CreateSequenceResponse);
     */
    createSequence(input: CreateSequenceRequest, options?: RpcOptions): UnaryCall<CreateSequenceRequest, CreateSequenceResponse> {
        const method = this.methods[34], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateSequenceRequest, CreateSequenceResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * GetSequence retrieves a sequence by ID.
     *
     * @generated from protobuf rpc: GetSequence(viam.app.data.v1.GetSequenceRequest) returns (viam.app.data.v1.GetSequenceResponse);
     */
    getSequence(input: GetSequenceRequest, options?: RpcOptions): UnaryCall<GetSequenceRequest, GetSequenceResponse> {
        const method = this.methods[35], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetSequenceRequest, GetSequenceResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * UpdateSequence updates the mutable fields of a sequence.
     *
     * @generated from protobuf rpc: UpdateSequence(viam.app.data.v1.UpdateSequenceRequest) returns (viam.app.data.v1.UpdateSequenceResponse);
     */
    updateSequence(input: UpdateSequenceRequest, options?: RpcOptions): UnaryCall<UpdateSequenceRequest, UpdateSequenceResponse> {
        const method = this.methods[36], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateSequenceRequest, UpdateSequenceResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * DeleteSequence deletes a sequence by ID.
     *
     * @generated from protobuf rpc: DeleteSequence(viam.app.data.v1.DeleteSequenceRequest) returns (viam.app.data.v1.DeleteSequenceResponse);
     */
    deleteSequence(input: DeleteSequenceRequest, options?: RpcOptions): UnaryCall<DeleteSequenceRequest, DeleteSequenceResponse> {
        const method = this.methods[37], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeleteSequenceRequest, DeleteSequenceResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * ListSequences lists sequences for a given organization.
     *
     * @generated from protobuf rpc: ListSequences(viam.app.data.v1.ListSequencesRequest) returns (viam.app.data.v1.ListSequencesResponse);
     */
    listSequences(input: ListSequencesRequest, options?: RpcOptions): UnaryCall<ListSequencesRequest, ListSequencesResponse> {
        const method = this.methods[38], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListSequencesRequest, ListSequencesResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * SequencesByDatasetID lists sequences that belong to the given dataset.
     *
     * @generated from protobuf rpc: SequencesByDatasetID(viam.app.data.v1.SequencesByDatasetIDRequest) returns (viam.app.data.v1.SequencesByDatasetIDResponse);
     */
    sequencesByDatasetID(input: SequencesByDatasetIDRequest, options?: RpcOptions): UnaryCall<SequencesByDatasetIDRequest, SequencesByDatasetIDResponse> {
        const method = this.methods[39], opt = this._transport.mergeOptions(options);
        return stackIntercept<SequencesByDatasetIDRequest, SequencesByDatasetIDResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * GetSequenceBinaryData returns paginated binary data records matching the
     * sequence's time range and binary resources.
     *
     * @generated from protobuf rpc: GetSequenceBinaryData(viam.app.data.v1.GetSequenceBinaryDataRequest) returns (viam.app.data.v1.GetSequenceBinaryDataResponse);
     */
    getSequenceBinaryData(input: GetSequenceBinaryDataRequest, options?: RpcOptions): UnaryCall<GetSequenceBinaryDataRequest, GetSequenceBinaryDataResponse> {
        const method = this.methods[40], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetSequenceBinaryDataRequest, GetSequenceBinaryDataResponse>("unary", this._transport, method, opt, input);
    }
}
